import React from 'react'
import PropTypes from 'prop-types';
import {useSelector} from "react-redux";

const MyPayments = ({style, className, ...props}) => {
    const window = useSelector(state => state?.getWindowSize);
    const strokeColor = window.color === 'My Payments' ? "#070707" : "#737373";

    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
            className={className}
        >
            <path
                d="M10.3 8.6C10.7167 8.6 11.0875 8.4375 11.4125 8.1125C11.7375 7.7875 11.9 7.4125 11.9 6.9875C11.9 6.5625 11.7375 6.1917 11.4125 5.875C11.0875 5.5583 10.7167 5.4 10.3 5.4C9.8833 5.4 9.5125 5.5583 9.1875 5.875C8.8625 6.1917 8.7 6.5625 8.7 6.9875C8.7 7.4125 8.8625 7.7875 9.1875 8.1125C9.5125 8.4375 9.8833 8.6 10.3 8.6ZM1.5 11.175V12.5V1.5V11.175ZM1.5 14C1.11667 14 0.77083 13.85 0.4625 13.55C0.15417 13.25 0 12.9 0 12.5V1.5C0 1.11667 0.15417 0.77083 0.4625 0.4625C0.77083 0.15417 1.11667 0 1.5 0H12.5C12.9 0 13.25 0.15417 13.55 0.4625C13.85 0.77083 14 1.11667 14 1.5V3.85H12.5V1.5H1.5V12.5H12.5V10.175H14V12.5C14 12.9 13.85 13.25 13.55 13.55C13.25 13.85 12.9 14 12.5 14H1.5ZM7.45 10.675C6.8833 10.675 6.4333 10.5083 6.1 10.175C5.7667 9.8417 5.6 9.4 5.6 8.85V4.175C5.6 3.60833 5.7667 3.1625 6.1 2.8375C6.4333 2.5125 6.8833 2.35 7.45 2.35H13.2C13.7667 2.35 14.2167 2.5125 14.55 2.8375C14.8833 3.1625 15.05 3.60833 15.05 4.175V8.85C15.05 9.4 14.8833 9.8417 14.55 10.175C14.2167 10.5083 13.7667 10.675 13.2 10.675H7.45ZM13.55 9.175V3.85H7.1V9.175H13.55Z"
                fill={strokeColor}/>
        </svg>
    )
}

MyPayments.propTypes = {
    fill: PropTypes.string
};

export default MyPayments
